<template>
  <div v-if="isVisible" class="tw:bg-yellow-200 tw:border-b tw:flex tw:items-center tw:justify-center tw:gap-3 tw:py-2 tw:px-4 tw:relative">
    <div class="tw:flex tw:items-center tw:gap-2" :class="{ 'tw:flex-wrap': isMobile }">
      <IconGoogle v-show="!isMobile" name="star" fill color="var(--tw-color-gray-900)" />
      <TextPlay color="var(--tw-color-gray-900)" size="sm" :text="$t('nps.desc')" />
      <ButtonPlayV2 target="_blank" :href="link" size="sm" variant="filled" color="var(--tw-color-gray-900)" :text="$t('nps.text_button')" />
    </div>
    <div class="tw:absolute tw:right-4">
      <ButtonPlayV2 
        variant="ghost"
        icon="close"
        size="sm"
        color="var(--tw-color-gray-900)"
        @click="dismissBanner"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';

const STORAGE_KEY = 'nps_banner_dismissed_at';
const DISMISS_DURATION_MS = 6 * 60 * 60 * 1000; // 6 horas em milissegundos

defineProps<{
  isMobile?: boolean;
  link: string;
}>();

const isVisible = ref(true);

function isDismissed(): boolean {
  const dismissedAt = localStorage.getItem(STORAGE_KEY);
  if (!dismissedAt) return false;
  
  const dismissedTime = parseInt(dismissedAt, 10);
  const now = Date.now();
  
  // Se passaram mais de 6 horas, não está mais escondido
  if (now - dismissedTime >= DISMISS_DURATION_MS) {
    localStorage.removeItem(STORAGE_KEY);
    return false;
  }
  
  return true;
}

function dismissBanner() {
  localStorage.setItem(STORAGE_KEY, Date.now().toString());
  isVisible.value = false;
}

onMounted(() => {
  isVisible.value = !isDismissed();
});
</script>
